import { styled } from '@mui/material';
import { LinkBubbleMenu, RichTextEditor } from 'mui-tiptap';

export const StyledRichTextEditor = styled(RichTextEditor)(({ theme }) => ({
    '& .MuiTiptap-RichTextContent-root': {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        maxHeight: '20rem',
        overflowY: 'auto',
        '& p': {
            fontSize: '0.875rem',
        },
    },
    '& .MuiTiptap-RichTextField-menuBar': {
        backgroundColor: theme.palette.common.white,
        padding: 0,
        border: 0,
        '& .MuiTiptap-RichTextField-content': {
            color: theme.palette.cement[500],
            padding: 0,

            '& .MuiButtonBase-root svg': {
                fill: theme.palette.cement[500],
            },
        },
    },
}));

export const StyledLinkBubbleMenu = styled(LinkBubbleMenu)(({ theme }) => ({
    '& .MuiTiptap-ControlledBubbleMenu-paper': {
        padding: theme.spacing(2.5, 3),
        borderRadius: '8px',
        backgroundColor: `${theme.palette.common.white}!important`,
        '& > div': {
            padding: 0,
        },
        '& h6': {
            fontSize: theme.typography.subtitle1.fontSize,
            fontFamily: theme.typography.subtitle1.fontFamily,
            lineHeight: theme.typography.subtitle1.lineHeight,
            fontWeight: theme.typography.subtitle1.fontWeight,
        },
    },
}));
